<template>
  <el-form-item label="胚纱类型" :label-width="labelWidth">
    <el-select
      v-model="selectYarnId"
      placeholder="请选择胚纱类型"
      style="width: 100%;"
      filterable
      clearable
      :disabled="disable"
    >
      <el-option
        v-for="item in yarns"
        :key="item.id"
        :label="item.typeName+'('+item.shortName+')'"
        :value="item.id"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  props: {
    labelWidth: String,
    yarnId: Number,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectYarnId: null,
      yarns: [],
      disable:false
    };
  },
  created: function() {
    console.log("yarn selector created");
    this.selectYarnId = this.yarnId;
    this.disable = this.disabled;
    var self = this;
    this.$axios.get("public/yarnType/query").then(function(response) {
      if (response.data.errorCode == "00000") {
        self.yarns = response.data.data;
      } else {
        self.$message.error(response.data.errorMsg);
      }
    });
  }
};
</script>